import { createAsyncThunk } from '@reduxjs/toolkit';

import type { FonteNotificacoes } from '@/types/notificationBell/types';

import { notificationBellService } from './services';

export const fetchNotifications = createAsyncThunk(
  'notification-bell/fetch',
  async (fonte: FonteNotificacoes) => notificationBellService.fetchNotifications(fonte),
);

export const markNotificationAsRead = createAsyncThunk(
  'notification-bell/markRead',
  async (params: { id: string; fonte: FonteNotificacoes }) => {
    await notificationBellService.markAsRead(params);
    return params;
  },
);

export const dismissNotification = createAsyncThunk(
  'notification-bell/dismiss',
  async (params: { id: string; fonte: FonteNotificacoes }) => {
    await notificationBellService.dismiss(params);
    return params;
  },
);

export const markAllNotificationsAsRead = createAsyncThunk(
  'notification-bell/markAllRead',
  async (fonte: FonteNotificacoes) => notificationBellService.markAllAsRead(fonte),
);
